// removed by extract-text-webpack-plugin
module.exports = {"absolute-center":"onfido-sdk-ui-Title-absolute-center","title":"onfido-sdk-ui-Title-title","titleWrapper":"onfido-sdk-ui-Title-titleWrapper","smaller":"onfido-sdk-ui-Title-smaller","fullScreen":"onfido-sdk-ui-Title-fullScreen"};


//////////////////
// WEBPACK FOOTER
// ./components/Title/style.css
// module id = 386
// module chunks = 1